// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.YFN8PpGqOIHmkqyRsXsY {
  display: flex;
  justify-content: right;
  align-items: center;
  gap: 0.5em;
  background-color: var(--bar-background);
  color: var(--border-color);
  padding: 0.1em 0.4em 0 0.4em;
  user-select: none;
}
.YFN8PpGqOIHmkqyRsXsY > .icon {
  display: flex;
  align-items: center;
  gap: 0.2em;
  font-size: 1.1rem;
  color: var(--bar-color);
  padding: 0.2em;
  border-radius: 4px;
  cursor: pointer;
}
.YFN8PpGqOIHmkqyRsXsY > .icon:hover {
  background-color: var(--hover-background);
}
.YFN8PpGqOIHmkqyRsXsY > .icon:disabled {
  opacity: 0.6;
  cursor: auto;
}
.YFN8PpGqOIHmkqyRsXsY > .icon:disabled:hover {
  background-color: inherit;
  color: revert;
}
.YFN8PpGqOIHmkqyRsXsY > .icon > span {
  font-family: var(--font-family);
  font-size: 0.8rem;
}
.YFN8PpGqOIHmkqyRsXsY > i {
  height: 1rem;
  width: 1px;
  background-color: var(--bar-color);
  opacity: 0.6;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `YFN8PpGqOIHmkqyRsXsY`,
	"icon": `icon`
};
export default ___CSS_LOADER_EXPORT___;
